import React, { useState, useEffect } from "react";
import { DataGrid, ruRU } from '@mui/x-data-grid';
import { useOutletContext, useNavigate } from "react-router-dom";
import api from "./api";
import Box from '@mui/material/Box';
import dictionary from "./dictionary";

const cellsFromObj = obj => Object.entries(obj).map(([key, value]) => [key, 0]);
const colsFromObj = obj => Object.entries({ name: { sLabel: 'Локация' }, ...obj, sum: { sLabel: 'Всего' } })
.map(([key, val]) => ({ field: key, headerName: val.sLabel, width: 200 }));

export function Rezerv() {
  const [loading, setLoading] = useState();
  const { aAreas, setAreas } = useOutletContext();
  const [aRows, setRows] = useState(aAreas.map(oArea => ({ ...oArea, ...Object.fromEntries(cellsFromObj(dictionary.gtin)) })));
  const [oRezervs, setRezervs] = useState();

  const fGetCSV = oCell => {
    let aCodes = oRezervs['area' + oCell.id]?.filter(sCis => sCis.slice(2, 16) == oCell.field);
    if (!aCodes?.length) return;
    aCodes = aCodes.map(id => '"' + id.replace(/"/g, '""') + '"');
    const link = document.createElement('a');
    const blob = new Blob(['1,' + dictionary.gtin[oCell.field].productName + ',,,,,КИЗ,' + aCodes.join(',')], { type: 'text/plain' });
    link.download = 'Коды для УПД (' + aCodes.length + ' шт.).csv';
    link.href = URL.createObjectURL(blob);
    link.click();
    URL.revokeObjectURL(link.href);
    // console.log(aCodes);
  }

  useEffect(() => {
    setLoading(true);
    api.getDb('reserved').then(oResp => {
      api.post('/cises/info?pg=water', Object.values(oResp.list).reduce((all, cur) => all.concat(cur)))
      .then(aCisData => {
        const aRetires = aCisData.filter(oCis => oCis.cisInfo.status == 'RETIRED' || oCis.cisInfo.ownerInn != oCis.cisInfo.producerInn).map(oCis => oCis.cisInfo.cis);
        if (aRetires.length) {
          Object.keys(oResp.list).forEach(sArea => {
            const aNewRezervs = [];
            oResp.list[sArea].forEach(sCis => aRetires.find(sRetired => sRetired == sCis) || aNewRezervs.push(sCis));
            oResp.list[sArea] = aNewRezervs;
          })
          api.putDb('reserved', oResp)
        }
        setRows(aPrev => {
          if (aPrev.find(oRow => oRow.id == 'all')) return aPrev;
          const oTotal = { id: 'all', name: 'Итого', sum: 0 }
          const aWill = [ ...aPrev, oTotal ];
          aWill.forEach(oRow => {
            const aAreasCises = oResp.list['area' + oRow.id];
            for (let sGtin in oRow) if (/^\d{14}$/.test(sGtin) && oRow.id != 'all') {
              if (!oTotal[sGtin]) oTotal[sGtin] = 0;
              oRow[sGtin] = aAreasCises?.filter(sCis => sCis.slice(2, 16) == sGtin).length || 0;
              oTotal[sGtin] += oRow[sGtin];
              oTotal.sum += oRow[sGtin];
            }
            if (oRow.id != 'all') oRow.sum = aAreasCises?.length || 0;
            // console.log(oRow);
            return oRow;
          });
          return aWill;
        });
        setRezervs(oResp.list);
        setLoading(false);
      });
    });
  }, []);

  return (
    <Box sx={{ height: '60vh', m: 1, cursor: 'default' }}>
      <DataGrid
        rows={aRows}
        columns={colsFromObj(dictionary.gtin)}
        aria-label='Total'
        localeText={ruRU.components.MuiDataGrid.defaultProps.localeText}
        hideFooter
        onCellClick={fGetCSV}
        loading={loading}
      />
    </Box>
  );
}
